<router-outlet />
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
